import React from "react";
import {
    Spin,
    Form,
    Card,
    Row,
    Col,
    Input,
    Button,
    message,
    Popconfirm,
} from "antd";

import { adminApi } from "../../../../../../api";
const {
    reqRoleAdd,
    reqRoleEdit,
    reqRoleDel,
    reqRoleDetail,
} = adminApi;

class RoleAdd extends React.Component {
    state = {
        loading: this.props.match.params.id ? true : false,
        detail: {},
    };
    id = this.props.match.params.id;

    onFinish = async (values) => {
        let response;
        if (!this.id) {
            for (let i in values) {
                if (!values[i]) {
                    delete values[i];
                }
                if (Array.isArray(values[i]) && !values[i].length) {
                    delete values[i];
                }
            }
        }
        if (this.id) {
            values.id = this.id;
            response = await reqRoleEdit(values);
            if (response && response.data) {
                message.success('修改成功');
                this.props.history.goBack();
            }
        } else {
            response = await reqRoleAdd(values);
            if (response && response.data) {
                message.success('添加成功');
            }
        }
    };

    delRole = async (params = {}) => {
        const response = await reqRoleDel({
            id: this.id
        });
        if (response && response.data) {
            message.success('删除成功');
            this.props.history.replace('/admin/authority/role/list');
        }
    };

    getRoleDetail = async (params = {}) => {
        const response = await reqRoleDetail(params);
        if (response && response.data) {
            this.setState({
                detail: response.data,
                loading: false
            });
        }
    };

    componentDidMount() {
        if (this.id) {
            // 获取详情
            this.getRoleDetail({
                rid: this.id
            });
        }
    }

    render() {
        const { detail } = this.state;

        return this.id && this.state.loading ? (
            <div className="loading-container">
                <Spin size="large" />
            </div>
        ) : (
            <Form onFinish={this.onFinish}>
                <Button
                    type="link"
                    icon="left"
                    onClick={() => {
                        this.props.history.goBack();
                    }}
                >返回</Button>

                <Card
                    title={
                        this.id ? "修改角色信息" : "添加角色"
                    }
                    style={{
                        marginBottom: 24,
                    }}
                    bordered={false}
                    extra={
                        this.id ? (
                            <Popconfirm
                                title="确定删除该角色吗?"
                                onConfirm={this.delRole}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Button>删除</Button>
                            </Popconfirm>
                        ) : null
                    }
                >
                    <Card
                        title="角色基本信息"
                        bordered={false}
                        type="inner"
                    >
                        <Row gutter={{ sm: 0, md: 16, lg: 24 }}>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="角色"
                                    name="name"
                                    initialValue={detail.name || ''}
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入角色',
                                        },
                                    ]}
                                >
                                    <Input placeholder="请输入角色" />
                                </Form.Item>
                            </Col>
                            {
                                !this.id ? (
                                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                        <Form.Item
                                            label="type"
                                            name="type"
                                            initialValue={detail.type || ''}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '请输入type',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="请输入type" />
                                        </Form.Item>
                                    </Col>
                                ) : null
                            }
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="备注"
                                    name="remark"
                                    initialValue={detail.remark || ''}
                                >
                                    <Input placeholder="备注" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Card>

                <div className="submit-footer">
                    <Button type="primary" htmlType="submit">
                        {
                            this.id ? '保存' : '提交'
                        }
                    </Button>
                </div>
            </Form>
        );
    }
}

export default RoleAdd;